import { useAppSelector } from '../../../store/hooks';
import type { RootState } from '../../../store';

/** The logged-in dashboard user has the Employee role (roles are comma-separated). */
export const useIsEmployee = (): boolean => {
    const role = useAppSelector((state: RootState) => state.users.adminProfile?.role || state.auth.adminRole || '');
    return String(role).split(',').some(r => r.trim().toLowerCase() === 'employee');
};
